// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

// navegación: verde oscuro (sidebar y navbar)
export const navBackgroundColor = '#1B5E20';
